<script lang="ts" setup>
import { ListFilter } from '@/graphql/types-optimize';

const props = withDefaults(
    defineProps<{
        dead?: boolean;
    }>(),
    {
        dead: false
    }
);
const jobSort = computed(() => undefined);
const jobFilter = computed(() => <ListFilter>{ limit: 10, page: 0 });
const { jobs } = useJobList(props.dead, jobFilter, jobSort);
function convertUtc(value: Date | undefined) {
    if (value) {
        const v = new Date(value);
        const n = new Date();
        const d = new Date(v.getTime() - n.getTimezoneOffset() * 60 * 1000);
        return d;
    }
    return undefined;
}
</script>
<template>
    <DataTable :value="jobs.items">
        <Column field="id" :header="$t('ux.labels.id')" />
        <Column field="ty" :header="$t('ux.labels.typ')">
            <template #body="{ data }">{{ $t(`dx.job.${data.ty}`) }}</template>
        </Column>
        <Column field="objectId" :header="$t('dx.wsobject.id')" />
        <Column field="enqueuedAt" :header="$t('ux.labels.created.text')">
            <template #body="{ data, field }">
                <DataTableDateTimeColumn
                    :value="convertUtc(data[field as string])"
                />
            </template>
        </Column>
        <Column field="scheduledAt" :header="$t('ux.labels.scheduled')">
            <template #body="{ data, field }">
                <DataTableDateTimeColumn
                    :value="convertUtc(data[field as string])"
                />
            </template>
        </Column>
        <Column field="startedAt" :header="$t('ux.labels.started')">
            <template #body="{ data, field }">
                <DataTableDateTimeColumn
                    :value="convertUtc(data[field as string])"
                />
            </template>
        </Column>
        <Column field="diedAt" :header="$t('ux.labels.executed')" />
        <Column field="retries" :header="$t('ux.labels.retries')" />
        <template #empty>
            <DataTableNoEntry />
        </template>
    </DataTable>
</template>
